import { render, staticRenderFns } from "./UsersFormGroup.vue?vue&type=template&id=63d7c24a"
import script from "./UsersFormGroup.vue?vue&type=script&lang=js"
export * from "./UsersFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports